import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearch } from "./useSearch";
import { extractMessage } from "helpers/extractError";
import { newDate } from "helpers/dateTools";

export const useFixDate = (value = {}) => {
  const {
    date,
    dates,
    startDate,
    endDate,
    isDispatch = false,
    action = null,
  } = value;

  const { setSnackbar } = useSearch();
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      if (dates || (startDate !== undefined || endDate !== undefined)) {
        const sDate = dates ? dates.startDate : startDate;
        const eDate = dates ? dates.endDate : endDate;

        if (isDispatch) {
          !sDate && dispatch(action("startDate", newDate()));
          !eDate && dispatch(action("endDate", newDate()));
        } else {
          !sDate && action({ startDate: newDate() });
          !eDate && action({ endDate: newDate() });
        }
      } else if (date) {
        if (isDispatch) {
          !date && dispatch(action("date", newDate()));
        } else {
          !date && action({ date: newDate() });
        }
      }
    } catch (error) {
      const err = extractMessage(error);
      setSnackbar(`fixDate hook error / ${err}`, "warning");
    }
  }, [date, dates?.startDate, dates?.endDate, startDate, endDate]);
};
